import { Badge } from '@sunstone/ui';
import { CheckCircle2, Loader2, XCircle } from 'lucide-react';
import type { BlockRendererProps } from '../registry';

export function ToolStatusBlockRenderer({ block }: BlockRendererProps) {
  const toolName = (block.metadata?.toolName as string) ?? 'Tool';
  const status = (block.metadata?.status as string) ?? block.status;

  const badge =
    status === 'completed' ? (
      <Badge className="bg-green-50 text-green-700 dark:bg-green-950 dark:text-green-300 gap-1">
        <CheckCircle2 className="w-3 h-3" />
        {status}
      </Badge>
    ) : status === 'failed' ? (
      <Badge variant="destructive" className="gap-1">
        <XCircle className="w-3 h-3" />
        {status}
      </Badge>
    ) : (
      <Badge className="bg-amber-50 text-amber-700 dark:bg-amber-950 dark:text-amber-300 gap-1">
        <Loader2 className="w-3 h-3 animate-spin" />
        {status}
      </Badge>
    );

  return (
    <div className="flex items-center gap-2 py-1 text-xs">
      {badge}
      <span className="text-muted-foreground">{toolName}</span>
      {block.content && <span className="text-muted-foreground">— {block.content}</span>}
    </div>
  );
}
